import React, { useEffect, useState } from 'react';
import { FeatureFlagsStatus } from './store/constants';

const FeatureFlagBoundary = ({ children, featureFlagsStatus, loadFeatureFlags }) => {
  const [requested, setRequested] = useState(false);

  useEffect(() => {
    loadFeatureFlags();
    setRequested(true);
  }, [loadFeatureFlags]);

  if (!requested || featureFlagsStatus === FeatureFlagsStatus.IDLE ||
      featureFlagsStatus === FeatureFlagsStatus.LOADING) {
    return <p role="status">Loading store settings…</p>;
  }
  if (featureFlagsStatus === FeatureFlagsStatus.ERROR) {
    return (
      <div role="alert">
        <p>Store settings could not be loaded. Please try again.</p>
        <button type="button" onClick={() => loadFeatureFlags()}>Try again</button>
      </div>
    );
  }
  return children;
};

export default FeatureFlagBoundary;
